<template>
    <div class="tab-pane">
        <el-tabs v-model="tabName" @tab-click="handleTabClick">
            <el-tab-pane name="tender">
                <div class="tab-label" slot="label"><div class="label-text">招标待办</div><div class="tag" v-if="tenderTotal">{{ tenderTotal }}</div></div>
                <TenderTable ref="tenderTable" @count="setTenderCount" />
            </el-tab-pane>
            <el-tab-pane name="contract">
                <div class="tab-label" slot="label"><div class="label-text">待签署合同</div><div class="tag" v-if="contractTotal">{{ contractTotal }}</div></div>
                <StoreTable
                    :config="config.contract"
                    :tableData="contractTableData"
                    :currentPage="contractParams.pageNo"
                    :total="contractTotal"
                    :loading="contractLoading"
                    @current-change="handlePageChangeOfContract"
                    @size-change="handleSizeChangeOfContract"
                    @view-btn="handleContractView"
                />
            </el-tab-pane>
            <el-tab-pane name="deposit">
                <div class="tab-label" slot="label"><div class="label-text">待支付合同押金</div><div class="tag" v-if="depositTotal">{{ depositTotal }}</div></div>
                <NoPaymentContractDepositTable ref="depositTable" @dataUpdate="getDepositCount" />
            </el-tab-pane>
            <el-tab-pane name="delegate">
                <div class="tab-label" slot="label"><div class="label-text">仓储委派函待办</div><div class="tag" v-if="delegateTotal">{{ delegateTotal }}</div></div>
                <StoreTable
                    :config="config.delegate"
                    :tableData="delegateTableData"
                    :currentPage="delegateParams.pageNo"
                    :total="delegateTotal"
                    :loading="delegateLoading"
                    @current-change="handlePageChangeOfDelegate"
                    @size-change="handleSizeChangeOfDelegate"
                />
            </el-tab-pane>
            <el-tab-pane name="salary">
                <div class="tab-label" slot="label"><div class="label-text">工人发薪预警</div><div class="tag" v-if="salaryTotal">{{ salaryTotal }}</div></div>
                <StoreTable
                    :config="config.salary"
                    :tableData="salaryTableData"
                    :currentPage="salaryParams.pageNo"
                    :total="salaryTotal"
                    :loading="salaryLoading"
                    @current-change="handlePageChangeOfSalary"
                    @size-change="handleSizeChangeOfSalary"
                />
            </el-tab-pane>
            <el-tab-pane name="perform">
                <div class="tab-label" slot="label"><div class="label-text">绩效整改</div><div class="tag" v-if="performTotal">{{ performTotal }}</div></div>
                <StoreTable
                    :config="config.perform"
                    :tableData="performTableData"
                    :currentPage="performParams.pageNo"
                    :total="performTotal"
                    :loading="performLoading"
                    @current-change="handlePageChangeOfPerform"
                    @size-change="handleSizeChangeOfPerform"
                />
            </el-tab-pane>
            <el-tab-pane name="source">
                <div class="tab-label" slot="label"><div class="label-text">需求资源</div></div>
                即将上线，敬请期待
                <!-- <StoreTable /> -->
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import bigDataLog from '@/utils/bigDataLog'
import TenderTable from './tenderTable.vue'
import StoreTable from './StoreTable.vue'
import NoPaymentContractDepositTable from './NoPaymentContractDepositTable.vue'
import config from './config.js'
import { supplierWarehouseDelegateSearh } from '../../lsrm/api/warehouseResourceManagement/warehouseDelegationLetter.js'
import { supSearch } from '../../lsrm/api/warehouseResourceManagement/loaderSalaryConfirm.js'
import { getPerformanceList } from '../../lsrm/api/warehouseResourceManagement/performanceAssessDetail.js';
import contractapi from '../../lsrm/api/contract/contractSigning';

export default {
    components: { TenderTable, StoreTable, NoPaymentContractDepositTable },
    inject: ['linkToPointPage'],
    data(){
        return {
            config,
            tabName: 'tender',
            tenderTotal: 0,
            depositTotal: 0,

            delegateParams: {
                auditStatusList: ['00', '01', '80', '2', '3', '30'], // 审批状态= 草稿、新建、撤回、待审批、审批中、驳回
                supplierSignStatusList: [ '2', '0', '3', '-1'], // 供应商签署状态 = 待发起、未签署、已撤回、签署失败
                warehouseWorkerSignStatusList: [ '2', '0', '1', '-1'], // 仓库人员签署状态= 待发起、未签署、已撤回、签署失败
                delegateStatus: '0', // 状态=停用
                pageNo: 1,
                pageSize: 10,
            },
            delegateTableData: [],
            delegateTotal: 0,
            delegateLoading: false,

            salaryParams: {
                confirmStatusList: ['3'], // 工资确认=未收到
                supplierCode: this.$store.state.supplier.supplierCode,
                pageNo: 1,
                pageSize: 10,
            },
            salaryTableData: [],
            salaryTotal: 0,
            salaryLoading: false,

            performParams: {
                recalculateOperationalQualityList: ['2', '3', '5'], // 运作质量=整改、整改约谈、运作风险
                type: '3',
                pageNo: 1,
                pageSize: 10,
            },
            performTableData: [],
            performTotal: 0,
            performLoading: false,

            contractParams: {
                contractStatuses: ['30', '40', '50', '60', '80'], // 与 合同签署 页保持一致
                noContractTypes: ['3'], // 与 合同签署 页保持一致
                contractStatus: '30', // 合同状态=待盖章
                suppliersCode: this.$store.state.supplier.supplierCode,
                pageNo: 1,
                pageSize: 10,
            },
            contractTableData: [],
            contractTotal: 0,
            contractLoading: false,
        }
    },
    computed: {
        ...mapGetters(['supplier', 'btnPermissions']),
    },
    methods: {
        loadDataOfTender() {
            this.$refs.tenderTable.getData()
        },
        setTenderCount(val) {
            this.tenderTotal = val
        },
        // getCount(countObj){
        //     this.countObj = countObj;
        //     this.count = countObj.count;
        //     this.tabList.forEach(item => {
        //         item.count = countObj[item.name];
        //     })
        // },
        
        // 仓储委派函待办相关
        loadDataOfDelegate() {
            if (!this.btnPermissions.includes('/storeWorkbench-90')) {
                return false
            }
            this.delegateLoading = true
            supplierWarehouseDelegateSearh(this.delegateParams).then(res => {
                if (res && +res.code === 0) {
                    const { list, totalCount } = res.data
                    this.delegateTotal = totalCount || 0
                    this.delegateTableData = list
                }
            }).finally(() => {
                this.delegateLoading = false
            })
        },
        handlePageChangeOfDelegate(pageNo) {
            this.delegateParams.pageNo = pageNo
            this.loadDataOfDelegate()
        },
        handleSizeChangeOfDelegate(pageSize) {
            this.delegateParams.pageNo = 1
            this.delegateParams.pageSize = pageSize
            this.loadDataOfDelegate()
        },
        // 工人发薪预警相关
        loadDataOfSalary() {
            if (!this.btnPermissions.includes('/storeWorkbench-100')) {
                return false
            }
            this.salaryLoading = true
            supSearch(this.salaryParams).then(res => {
                if (res && +res.code === 0) {
                    const { list, totalCount } = res.data
                    this.salaryTotal = totalCount || 0
                    this.salaryTableData = list
                }
            }).finally(() => {
                this.salaryLoading = false
            })
        },
        handlePageChangeOfSalary(pageNo) {
            this.salaryParams.pageNo = pageNo
            this.loadDataOfSalary()
        },
        handleSizeChangeOfSalary(pageSize) {
            this.salaryParams.pageNo = 1
            this.salaryParams.pageSize = pageSize
            this.loadDataOfSalary()
        },
        // 绩效整改相关
        loadDataOfPerform() {
            if (!this.btnPermissions.includes('/storeWorkbench-110')) {
                return false
            }
            this.performLoading = true
            getPerformanceList(this.performParams).then(res => {
                if (res && +res.code === 0) {
                    const { list, totalCount } = res.data
                    this.performTotal = totalCount || 0
                    this.performTableData = list
                }
            }).finally(() => {
                this.performLoading = false
            })
        },
        handlePageChangeOfPerform(pageNo) {
            this.performParams.pageNo = pageNo
            this.loadDataOfPerform()
        },
        handleSizeChangeOfPerform(pageSize) {
            this.performParams.pageNo = 1
            this.performParams.pageSize = pageSize
            this.loadDataOfPerform()
        },
        // 待签署合同相关
        loadDataOfContract() {
            if (!this.btnPermissions.includes('/storeWorkbench-120')) {
                return false
            }
            this.contractLoading = true
            contractapi.get(this.contractParams).then(res => {
                if (res && +res.code === 0) {
                    const { list, totalCount } = res.data
                    this.contractTotal = totalCount || 0
                    this.contractTableData = list
                }
            }).finally(() => {
                this.contractLoading = false
            })
        },
        handlePageChangeOfContract(pageNo) {
            this.contractParams.pageNo = pageNo
            this.loadDataOfContract()
        },
        handleSizeChangeOfContract(pageSize) {
            this.contractParams.pageNo = 1
            this.contractParams.pageSize = pageSize
            this.loadDataOfContract()
        },
        handleContractView(row) {
            bigDataLog.sendDetailMessageByNames(`仓储工作台,,,待签署合同-去查看`);
            const pageParams = {
                path: '/lsrm/contractSigning',
                query: {
                    contractCode: row.contractCode,
                }
            };
            this.linkToPointPage && this.linkToPointPage(pageParams);
        },
        // 待支付合同押金相关
        loadDataOfDeposit() {
            if (!this.btnPermissions.includes('/storeWorkbench-130')) {
                return false
            }
            this.$refs.depositTable.getData();
        },
        // 获取待支付合同押金数量
        getDepositCount({ totalCount }) {
            this.depositTotal = totalCount;
        },

        handleTabClick(tab) {
            const tabName = tab.name || '';
            if (tabName === 'tender') {
                this.loadDataOfTender();
            } else if (tabName === 'source') {
                // TODO 敬请期待
            } else if (tabName === 'delegate') {
                this.loadDataOfDelegate()
            } else if (tabName === 'salary') {
                this.loadDataOfSalary()
            } else if (tabName === 'perform') {
                this.loadDataOfPerform()
            } else if (tabName === 'contract') {
                this.loadDataOfContract()
            } else if (tabName === 'deposit') {
                this.loadDataOfDeposit();
            }
        },
        freshData() {
            this.handleTabClick({ name: this.tabName })
        },
    },
    mounted() {
        this.loadDataOfTender()
        this.loadDataOfDelegate()
        this.loadDataOfSalary()
        this.loadDataOfPerform()
        this.loadDataOfContract()
        this.loadDataOfDeposit()
    },
};
</script>
<style lang="less" scope>
.tab-pane {
    border-radius: 4px;
    // padding: 16px 24px;
    background: #fff;
    .el-tabs__nav-wrap {
        padding: 0 24px;
    }

    .el-tabs__nav {
        padding-top: 24px;
    }

    .el-tabs__content {
        padding: 0 24px 24px 24px;
    }
    .tab-label{
        display: flex;
        align-items: center;
        .label-text{
            font-size: 16px;
        }
        .tag{
            font-size: 12px;
            border-radius: 10px;
            background: #F44837;
            line-height: 16px;
            padding: 0 6px;
            margin-left: 5px;
            color: #fff;
        }
    }

    .el-tabs__item {
        height: 40px;
        line-height: 40px;
    }

    .el-tabs__item.is-active {
        color: #2881FF;
    }

    .el-tabs__active-bar {
        background: #2881FF;
    }

    .el-tabs__item:hover {
        color: #2881FF;
    }

    .el-button--text {
        color: #2881FF;
    }

    .el-table {
        border-radius: 4px 4px 0 0;
    }

    .el-pager li {
        min-width: 24px;

        &.active {
            background: #E5F0FE;
            border-radius: 3px;
        }
    }
}
</style>
